<script setup>
import {defineProps, defineEmits} from "vue";

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
    block: Boolean,
})

const emit = defineEmits(["press"]);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        v-if="show"
        color="purple"
        :loading="loading"
        :text="$t('common.archive')"
        icon="mdi-archive"
        @press="press"
    />
</template>

<style scoped>

</style>